import {
    Box,
    Stack,
    Button,
    useTheme
} from "@mui/material";
import { tokens } from "../../theme";
import {observer} from "mobx-react-lite";
import useResponsive from "../../hooks/useResponsive";

import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import Header from "../../components/Header";

const AppFaq = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const isDesktop = useResponsive("up", "md");
    const isMobile = useResponsive("between", "md", "xs", "sm");

    return (
        <Box 
            ml= {isMobile ? "0px" : "20px"}
            mr= {isMobile ? "0px" : "20px"}
        >
            {/* HEADER */}
            {!isMobile && 
                <Box display="flex" justifyContent="space-between" alignItems="center" height={'100px'}>
                    <Header title="FAQ" subtitle="FAQ" />

                    {/* <Box>
                        <Button
                            onClick={() => {handleOpenQueue({})}}
                            sx={{
                                backgroundColor: colors.greenAccent[700],
                                color: colors.grey[100],
                                fontSize: "14px",
                                fontWeight: "bold",
                                padding: "10px 20px",
                            }}
                        >
                        <HeadsetMicIcon sx={{ mr: "10px" }} />
                            Queue status
                        </Button>
                    </Box> */}
                </Box>
            }
            {/* CONTEXT */}
            <Stack 
                direction="row"
                alignItems="stretch"
                spacing={1.5}
                sx={{ 
                    height: isMobile ? "calc(100vh - 58px)" : "calc(100vh - 58px - 100px)", 
                    // height: "100%", 
                    minWidth: "320px" 
                }} 
            >

                
            </Stack>
        </Box>
    )
};

export default observer(AppFaq);